import React from 'react';
import { Link } from 'react-router-dom';
import { ListItem, ListItemIcon, ListItemText, Typography } from "@material-ui/core";

export function SidebarItem({ item, page, classes, classesIcon }) {
  if (!item.show) return null;

  const isActive = page === item.key;

  return (
    <ListItem
      button
      replace
      component={Link}
      to={item.path}
      className={isActive ? classes.backgroundActived : ''}
      disabled={item.disabled}
    >
      <ListItemIcon classes={classesIcon}>
        {item.isSvg ? (
          <item.icon style={{ fill: isActive ? 'var(--primary)' : '#737373' }} />
        ) : (
          <item.icon color={isActive ? 'primary' : 'inherit'} />
        )}
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography variant="subtitle2" color={isActive ? 'primary' : 'inherit'}>
            {item.label}
          </Typography>
        }
      />
    </ListItem>
  );
}